// scrolling-text-section.js
class ScrollingTextSection {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.marquee = sectionElement.querySelector('.scrolling-marquee');
    this.tracks = sectionElement.querySelectorAll('.marquee-track');
    this.speed = 1; // Por el momento dejaremos esta configuracion no dinamica.
    this.direction = this.marquee.dataset.direction || 'rtl';
    this.pauseOnHover = true; // Por el momento dejaremos esta configuracion no dinamica.
    
    this.init();
  }
  
  init() {
    this.setupAnimation();
    this.duplicateContent();
    this.setupEventListeners();
  }
  
  setupAnimation() {
    const duration = 100 / this.speed;
    
    this.tracks.forEach(track => {
      track.style.animationDuration = `${duration}s`;
      
      if (this.direction === 'ltr') {
        track.style.animationName = 'marquee-scroll-reverse';
      }
    });
    
    // Add reverse animation for LTR
    if (this.direction === 'ltr') {
      this.addLTRAnimation();
    }
  }
  
  addLTRAnimation() {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes marquee-scroll-reverse {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(0);
        }
      }
    `;
    document.head.appendChild(style);
  }
  
  duplicateContent() {
    // Ensure we have enough duplicated content for smooth scrolling
    this.tracks.forEach(track => {
      const content = track.innerHTML;
      // Add multiple copies to ensure continuous scrolling
      for (let i = 0; i < 3; i++) {
        track.innerHTML += content;
      }
    });
  }
  
  setupEventListeners() {
    if (this.pauseOnHover) {
      this.marquee.addEventListener('mouseenter', () => {
        this.tracks.forEach(track => {
          track.style.animationPlayState = 'paused';
        });
      });
      
      this.marquee.addEventListener('mouseleave', () => {
        this.tracks.forEach(track => {
          track.style.animationPlayState = 'running';
        });
      });
    }
    
    // Handle reduced motion preference
    this.handleReducedMotion();
  }
  
  handleReducedMotion() {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    
    if (reducedMotion.matches) {
      this.tracks.forEach(track => {
        track.style.animation = 'none';
      });
    }
    
    reducedMotion.addEventListener('change', (e) => {
      if (e.matches) {
        this.tracks.forEach(track => {
          track.style.animation = 'none';
        });
      } else {
        this.setupAnimation();
      }
    });
  }
  
  updateSpeed(newSpeed) {
    this.speed = newSpeed;
    const duration = 100 / this.speed;
    
    this.tracks.forEach(track => {
      track.style.animationDuration = `${duration}s`;
    });
  }
}

// Initialize all scrolling text sections
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.scrolling-text-section');
  sections.forEach(section => {
    new ScrollingTextSection(section);
  });
});

// Handle dynamic section loading in Shopify
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', function(e) {
    const section = e.target.querySelector('.scrolling-text-section');
    if (section) {
      new ScrollingTextSection(section);
    }
  });
}